<ng-container *transloco="let t">
  <div class="w-full space-y-2 rounded-xl border border-gray-200 bg-gray-100 p-4">
    <div class="flex items-center justify-between">
      <div class="text-sm font-medium tracking-tight text-gray-700">
        @if (hasFinished()) {
          <div class="flex items-center gap-1.5">
            <IIcon name="checkCircle" class="text-green-500" />
            <span>{{ t("bulk-upload-run.import_completed") }}</span>
          </div>
        } @else {
          <span>{{ t("bulk-upload-run.import_in_progress") }}</span>
        }
      </div>
      <div class="space-x-1 text-sm">
        <span class="text-gray-400">{{ completed() }}</span>
        <span class="text-gray-800">/</span>
        <span class="text-gray-800">{{ total() }}</span>
      </div>
    </div>
    <div class="w-full">
      <IProgressBar class="w-full" [progress]="ratio()" />
    </div>
    <div class="text-xs text-gray-500">
      {{ t("bulk-upload-run.please_do_not_close_this_page_until_the_import_is_complete") }}
    </div>
  </div>
</ng-container>
